import { stripeAddressSchema } from '@inkitt/contracts-common';
import { z } from 'zod';
import { c } from '../contract';

const purchaseType = z.enum(['payment', 'subscription']);

export const paymentRouter = c.router(
  {
    createIntent: {
      summary: 'Creates a stripe payment intent',
      method: 'POST',
      path: '/create-intent',
      body: z.object({
        locale: z.string(),
        /** Only required if user is making an anonymous purchase. For authenticated users, their account email */
        checkoutEmail: z.string().email().optional(),
        storyId: z.string().optional(),
        episodeNumber: z.string().optional(),
        address: stripeAddressSchema.nullable(),
      }),
      responses: {
        200: z.object({
          clientSecret: z.string(),
          returnUrl: z.string(),
          newStripeCustomerId: z.string().optional(),
          purchaseType,
        }),
        409: z.object({ reason: z.literal('already_subscribed') }),
        422: z.literal('Unprocessable Entity'),
      },
    },
  },
  { pathPrefix: '/payment' },
);
